import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import taskValidator from './cannot-be-treated-validator'

export default createUIDefinition({
    taskName: taskName.ENTER_PHYSICIAN_FEEDBACK,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator,
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/enter-physician-feedback.js